class IconTextList implements ng.IComponentController {
    list: anm.IconTextListItem[];
}

angular.module('animatronApp.iconTextList', []).component('iconTextList', {
    bindings: {
        list: '<',
    },
    controller: IconTextList,
    templateUrl: require('landing-template/components/icon-text-list.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/landing-template/components/IconTextList.ts